const e="*",o={mode:"new"};export{e as ASTERISK,o as REGISTRATION_OPTION};
